import { createMainResourceREST } from '../resource';
import {
  CRSiteBody,
  CRSiteBodyAPI,
  CRSiteKey,
  CRSiteSummary,
  CRSiteSummaryAPI,
  SitesActions,
  SitesState,
} from './types';

type AnySite = CRSiteKey | CRSiteSummary | CRSiteBody | undefined;

function sameKeySite(a: AnySite, b: AnySite): boolean {
  return a?.siteId === b?.siteId;
}

function getEndpointSite(key: AnySite): string {
  return key ? `/sites/${key.siteId}/` : '/sites/';
}

function parseSiteSummary(siteSummary: CRSiteSummaryAPI): CRSiteSummary {
  return siteSummary;
}

function parseSiteBody(siteDetail: CRSiteBodyAPI): CRSiteBody {
  return siteDetail;
}

const sitesStateSelector = (state: any): SitesState => state.sites;

const sitesKeySelector = ({
  siteId,
}: CRSiteBody | CRSiteSummary): CRSiteKey => ({
  siteId,
});

function mergeSiteBody(lastBody: CRSiteBody, currentBody: CRSiteBody) {
  return currentBody;
}

function combineSummaryBodySite(summary?: CRSiteSummary): CRSiteSummary {
  return {
    ...summary!,
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'sites',
  getEndpointSite,
  sitesStateSelector,
  sameKeySite,
  parseSiteBody,
  parseSiteSummary,
  mergeSiteBody,
  combineSummaryBodySite,
);

const sitesActions: SitesActions = actions;

export * from './types';

export {
  sitesActions,
  reducer as sitesReducer,
  watches as sitesWatches,
  sitesStateSelector,
  sitesKeySelector,
};
